import { DateTime } from 'luxon';

import { User } from '@work4all/models/lib/Classes/User.entity';
import { UserPresenceTimeInfo } from '@work4all/models/lib/Classes/UserPresenceTimeInfo.entity';
import { TimeStampKind } from '@work4all/models/lib/Enums/TimeStampKind.enum';

import {
  checkIsBeforeEarliestCheckinTime,
  getEearliestCheckinTime,
} from '../../../time-tracker/utils/checkIsBeforeEarliestCheckingTime';

import { TimePreviewActions } from './types';

export const calculateTimeCardPreviewActions = (
  block: UserPresenceTimeInfo,
  user?: User
): TimePreviewActions[] => {
  if (!block) return ['Add'];

  const last = block.items[block.items.length - 1];

  if (last.kind === TimeStampKind.TAG_BEENDET) return ['Add'];
  if (last.kind === TimeStampKind.PAUSENBEGINN) return ['Resume'];

  const first = block.items[0];
  const startDate = DateTime.fromISO(first.timestamp);

  const earliestCheckinTime = getEearliestCheckinTime(
    user.kommtGehtMinimaleStartZeit
  );
  const isToday = startDate.hasSame(earliestCheckinTime, 'day');
  const isBeforeEarliestCheckinTime = checkIsBeforeEarliestCheckinTime(
    getEearliestCheckinTime(user.kommtGehtMinimaleStartZeit)
  );

  if (isToday && isBeforeEarliestCheckinTime) return ['End'];

  return ['Pause', 'End'];
};

type IsValidPauseProps = {
  start: string | undefined;
  end: string | undefined;
  minimumPauseAmount: number;
};

export const isValidPause = ({
  start,
  end,
  minimumPauseAmount = 0,
}: IsValidPauseProps) => {
  if (!start || !end || minimumPauseAmount === 0) return true;

  const startDateTime = DateTime.fromISO(start);
  const endDateTime = DateTime.fromISO(end);
  const pauseAmount = endDateTime.diff(startDateTime, ['minutes']).minutes;

  return pauseAmount >= minimumPauseAmount;
};
